<template>
  <email-filter
    :options="emailActivityTypeOptions"
    :title="t('COMMON.TYPE')"
    placeholder-key="ACTIVITY.FILTERS.TYPE"
    :render-component="EmailTypeOption"
    query-key="email_is_outgoing"
    :toggle-from-parent
  />
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";

import { emailActivityTypeOptions } from "@/helpers/constants/emails";

import EmailFilter from "@/components/communicationLogs/filters/emailFilters/EmailFilter.vue";
import EmailTypeOption from "@/components/communicationLogs/filters/emailFilters/EmailTypeOption.vue";

const { toggleFromParent = false } = defineProps<{
  toggleFromParent?: boolean;
}>();

const { t } = useI18n();
</script>
